angular.module('nv.SchoolMetricsModule').component('creditMetricsTable', {
  template: require('./credit-metrics-table.html'),
  bindings: {
    cohort: '=',
    changeMadeInMetrics: '=',
    creditTableCopy: '=',
  },
  controller: 'CreditMetricsTableCtrl',
});
